import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    orderListData:[],   //盒子列表
    pagination: {
      page: 1,
      size: 10
    },
    total: 0,
    showWhiteList: false,
    selectData: {},
    allCoins: []
  },
  getters: {
  },
  mutations: {
    orderList(state, data) {
      state.orderListData = data;
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setShowWhiteList(state, payload) {
      state.showWhiteList = payload
    },
    setSelectData(state, payload) {
      state.selectData = payload
    },
    setAllCoins(state, allCoins) {
      state.allCoins = allCoins
    }
  },
  actions: {
    //订单列表
    getBoxListA({ commit }, data) {
      api.getBoxList(data).then(res => {
        let records = res.data.records;
        records.forEach(item => {
          item.blindBoxName = JSON.parse(item.blindBoxName)
          item.nameObj = Object.keys(item.blindBoxName).map(v => ({lang: v, name: item.blindBoxName[v]}))
        });
        commit('orderList', res.data.records);
        commit('setTotal', res.data.total)
        commit('setPagination', { page: data.page, size: data.size })
      });
    },

  }
};
appStore.registerModule('newMagicBox', store);
